import React from 'react'
import {AlertDialog} from 'react-onsenui'
import Loader from 'react-loader-spinner';
import firebase from 'firebase/app';
import 'firebase/functions';

import {withRouter} from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import {showToastMessage} from "../../modules/toast";
import {showAlertMessage} from "../../modules/alert";

class UserInfoDialog extends React.Component {
    state = {
        nickname: '',
        name: '',
        email: '',
        isLoading: false,
    };

    componentDidMount(){
        this.setState({isLoading: true});
        //firebase.functions().useFunctionsEmulator('http://localhost:5000');
        const getUserInfo = firebase.functions().httpsCallable('getUserInfo');
        getUserInfo({uid: this.props.uid}).then((result) => {
            if(result.data.result === 'success'){
                let d = result.data.data;
                this.setState({nickname: d.nickname, name: d.name, email: d.email, isLoading: false});
            }else{
                this.props.showToastMessage('사용자 정보를 가져오는데 문제가 발생하였습니다.');
            }
        });

    }

    componentWillReceiveProps(nextProps) {

    }

    componentWillMount() {
    }

    closeUserInfoDialog = () => {
        this.props.hide();
    };

    goToScheduleList = (type, parameter) => {
        this.props.history.push({
            pathname: '/listSchedule',
            state: {type: type, parameter: parameter}
        });
    };

    render() {
        return (
           <div>
               <AlertDialog className="user-info-alert-dialog" isOpen={this.props.open} cancelable={false} modifier={'material'}>

                   {
                       !this.state.isLoading ?
                           <div>
                               <div className="alert-dialog-title">사용자 정보</div>
                               <div className="alert-dialog-content">
                                   <div><small>닉네임</small></div>
                                   <div>{this.state.nickname}</div>
                                   <div><small>이름</small></div>
                                   <div>{this.state.name}</div>
                                   <div><small>이메일</small></div>
                                   <div>{this.state.email}</div>
                               </div>
                           </div>
                           :
                           <div className="alert-dialog-footer">
                               <div className='text-center'>
                                   <Loader type="ThreeDots" color="#00BFFF" height={40} width={40} />
                               </div>
                           </div>
                   }

                   <div className="alert-dialog-footer">
                       <button className="alert-dialog-button alert-dialog-button-no" onClick={this.closeUserInfoDialog}>
                           닫기
                       </button>
                       {
                           !this.state.isLoading && this.state.nickname !== '' ?
                               <button className="alert-dialog-button" onClick={() => this.goToScheduleList('USER', {uid: this.props.uid, nickname: this.state.nickname})}>
                                   작성 일정 보기
                               </button>
                               :
                               null
                       }
                   </div>
               </AlertDialog>
           </div>
        )
    }
}

const mapStateToProps = ({ user }) => ({
    userInfo: user.userInfo
});

const mapDispatchToProps = dispatch => ({
    showToastMessage: message => dispatch(showToastMessage(message)),
    showAlertMessage: (message, title) => dispatch(showAlertMessage(message, title)),
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(UserInfoDialog))